"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LIB_VERSION = void 0;
var LIB_VERSION = exports.LIB_VERSION = "@dragon/core 1.5.16";
//# sourceMappingURL=version.js.map